import type { FC, HTMLAttributes, ReactNode } from 'react'

import { cn } from '@/lib/utils'

export type BadgeVariant = 'default' | 'primary' | 'accent' | 'success' | 'warning' | 'danger' | 'outline' | 'ink'

interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
    variant?: BadgeVariant
}

const VARIANTS: Record<BadgeVariant, string> = {
    default: 'bg-muted text-muted-foreground',
    primary: 'bg-primary/10 text-primary',
    accent: 'bg-accent text-accent-foreground',
    success: 'bg-success-soft text-success',
    warning: 'bg-warning-soft text-warning',
    danger: 'bg-danger-soft text-destructive',
    outline: 'border border-border text-foreground',
    ink: 'bg-ink text-ink-foreground'
}

export const Badge: FC<BadgeProps> = ({ variant = 'default', className, ...props }): ReactNode => {
    return (
        <span
            className={cn('inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-semibold [&_svg]:size-3.5', VARIANTS[variant], className)}
            {...props}
        />
    )
}
